import $ from 'jquery'

$('.acc-item .acc-item__button').on('click', function () {
  const clickedItem = $(this).parent()
  clickedItem.toggleClass('collapsed')

  const allItems = clickedItem.parent().find('.acc-item')
  allItems.not(clickedItem).addClass('collapsed')
  allItems.not(clickedItem).find('.acc-item__content').slideUp(250)

  if (clickedItem.hasClass('collapsed')) {
    clickedItem.find('.acc-item__content').slideUp(250)
  } else {
    clickedItem.find('.acc-item__content').slideDown(250)
  }
})

$('.acc-item').parent().find('.acc-item__button').eq(0).click()
